export default "__VITE_PUBLIC_ASSET__08c33379__"